module.exports = __webpack_public_path__ + "static/img/sp_4.fe00161.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/sports/sp_4.png
// module id = 843
// module chunks = 1